<template>
  <validation-observer ref="simpleRules">
    <b-card>
      <b-form enctype="multipart/forn-data">
        <!-- Media -->
        <b-media class="mb-2">
          <template #aside>
            <b-avatar :src="imgAvatar" size="90px" rounded />
          </template>
          <h4 class="mb-1">Avatar (Max Size 2Mb)</h4>
          <div class="d-flex flex-wrap">
            <b-button variant="primary" @click="$refs.refInputEl.click()">
              <input
                ref="refInputEl"
                type="file"
                @change="uploadImage"
                class="d-none"
              />
              <span class="d-none d-sm-inline">Add</span>
              <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
            </b-button>
          </div>
        </b-media>

        <!-- User Info: Input Fields -->

        <b-row>
          <!-- Field: identification_number -->
          <b-col cols="12" md="4">
            <b-form-group label="Identification Number" label-for="idN">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Identification Number"
              >
                <b-form-input
                  id="idN"
                  v-model="model.identification_number"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: First  Name -->
          <b-col cols="12" md="4">
            <b-form-group label="First Name" label-for="firstName">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="First Name"
              >
                <b-form-input
                  id="firstName"
                  v-model="model.first_name"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Last  Name -->
          <b-col cols="12" md="4">
            <b-form-group label="Last Name" label-for="lastName">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Last Name"
              >
                <b-form-input
                  id="lastName"
                  v-model="model.last_name"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Email -->
          <b-col cols="12" md="4">
            <b-form-group label="Email" label-for="email">
              <validation-provider
                #default="{ errors }"
                rules="required|email"
                name="Email"
              >
                <b-form-input
                  id="email"
                  v-model="model.mail"
                  :state="errors.length > 0 ? false : null"
                  @change="verifyEmail"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Phone Number -->
          <b-col cols="12" md="4">
            <b-form-group label="Phone Number" label-for="phoneNumber">
              <validation-provider
                #default="{ errors }"
                rules="required|integer"
                name="Phone Number"
              >
                <b-form-input
                  id="phoneNumber"
                  v-model="model.phone_number"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Birth Date-->
          <!-- <b-col cols="12" md="4">
            <b-form-group label="Date of Birth" label-for="birthDate">
              <div>
                <b-input-group>
                  <b-form-input
                    id="example-input"
                    v-model="model.birth_date"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    show-decade-nav
                  />

                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="model.birth_date"
                      show-decade-nav
                      button-only
                      right
                      locale="en-US"
                      aria-controls="example-input"
                      :max="maxDate"
                      @context="onContext"
                    />
                  </b-input-group-append>
                </b-input-group>
              </div>
            </b-form-group>
          </b-col> -->

          <!-- Field: BirthDate -->
          <b-col cols="12" md="4">
            <b-form-group>
              <label>Birth Date</label>
              <validation-provider
                #default="{ errors }"
                name="Birth Date"
                rules=""
              >
                <flat-pickr
                  v
                  class="form-control"
                  v-model="model.birth_date"
                  :state="errors.length > 0 ? false : null"
                  placeholder=""
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Role -->
          <b-col cols="12" md="4">
            <b-form-group label="City" label-for="city">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="City"
              >
                <v-select
                  :options="cityOptions"
                  v-model="model.cityId"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  input-id="city"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Status -->
          <b-col cols="12" md="4">
            <b-form-group label="Status" label-for="user-status">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                v-model="model.status"
                input-id="user-status"
              />
            </b-form-group>
          </b-col>

          <!-- Field: Adress-->
          <b-col cols="12" md="4">
            <b-form-group label="Address" label-for="adress">
              <b-form-textarea
                id="adress"
                v-model="model.adress"
                rows="2"
                max-rows="8"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-col cols="12" md="4" class="mb-2">
          <b-form-checkbox
            v-model="model.is_access"
            name="check-button"
            switch
            inline
          >
            Is Access
          </b-form-checkbox>
        </b-col>

        <!-- Aqu se comienza la validacion de password -->
        <div v-show="model.is_access">
          <b-row>
            <!-- Field: User  Name -->
            <b-col cols="12" md="4">
              <b-form-group label="User Name" label-for="userName">
                <validation-provider
                  v-if="model.is_access"
                  #default="{ errors }"
                  rules="required"
                  name="User Name"
                >
                  <b-form-input
                    id="userName"
                    v-model="model.user_name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Field: Password -->
            <b-col cols="12" md="4">
              <b-form-group label="Password" label-for="password">
                <validation-provider
                  v-if="model.is_access"
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-form-input
                    id="password"
                    v-model="model.password"
                    type="password"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="4">
              <b-form-group label="Rol" label-for="rol">
                <validation-provider
                  v-if="model.is_access"
                  #default="{ errors }"
                  rules="required"
                  name="Rol"
                >
                  <v-select
                    :options="rolsOptions"
                    v-model="model.rolId"
                    :reduce="(val) => val.value"
                    :clearable="false"
                    input-id="rol"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <!-- Fin del crear usuario -->
        <b-button
          variant="primary"
          type="submit"
          @click.prevent="validationForm"
        >
          Create Employee
        </b-button>
      </b-form>
    </b-card>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormDatepicker,
  BFormTextarea,
  BFormFile,
  BInputGroupPrepend,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import store from "@/store";
import router from "@/router";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";

import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import EmployeeStoreModule from "../employeeStoreModule";

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    flatPickr,
  },

  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-user";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, EmployeeStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });
    const toast = useToast();
    const validations = ref({
      required,
      confirmed,
      password,
      email,
      min,
      integer,
      url,
      alpha,
      between,
      digits,
      length,
      alphaDash,
    });

    const parser = JSON.parse(localStorage.getItem("userData"));

    const model = ref({
      identification_number: "",
      first_name: "",
      last_name: "",
      mail: "",
      phone_numbre: "",
      birth_date: "",
      cityId: "",
      adress: "",
      id_user: 1,
      is_access: false,
      type: 1,
      user_name: "",
      rolId: null,
    });

    const imgAvatar = ref("");

    const cityOptions = ref([]);

    const rolsOptions = ref([]);

    const simpleRules = ref(null);

    const statusOptions = [
      { label: "Active", value: true },
      { label: "Inactive", value: false },
    ];

    const maxDate = ref(new Date());

    const a = [];

    let formatted = "";
    let selected = "";
    store
      .dispatch("app-user/fetchHelpers")
      .then((response) => {
        const { cities } = response.data.data;

        cities.map((data, item) => {
          a.push({ label: data.name, value: data.id, id: item });
        });

        cityOptions.value = a;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });

    const b = [];
    store
      .dispatch("app-user/fetchHelpers")
      .then((response) => {
        const { rols } = response.data.data;

        rols.map((data, item) => {
          b.push({ label: data.name, value: data.id, id: item });
        });
        rolsOptions.value = b;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });
    const uploadImage = (e) => {
      let file = e.target.files[0];
      if (file.size > 2097152) {
        return toast({
          component: ToastificationContent,
          props: {
            title: `ERROR`,
            icon: "AlertOctagonIcon",
            variant: "danger",
            text: `image exceeds the allowed weight 2Mb`,
            solid: true,
          },
        });
      }
      Object.assign(model.value, { file: file });
      viewImage(file);
    };

    const viewImage = (image) => {
      let reader = new FileReader();
      reader.onload = (e) => {
        imgAvatar.value = e.target.result;
      };
      reader.readAsDataURL(image);
    };

    const onContext = (ctx) => {
      // The date formatted in the locale, or the `label-no - date - selected` string
      formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      selected = ctx.selectedYMD;
    };

    const verifyEmail = () => {
      store
        .dispatch("app-user/verifyEmail", { mail: model.value.mail })
        .then((response) => {
          if (response.data.ok) {
            model.value.mail = "";
            toast({
              component: ToastificationContent,
              props: {
                title: `ERROR`,
                icon: "AlertOctagonIcon",
                text: `${response.data.msg}`,
                variant: "danger",
              },
            });
          }
        });
    };

    const validationForm = () => {
      simpleRules.value.validate().then((success) => {
        if (success) {
          console.log("vamos guardar el modelo", model);

          let formData = new FormData();
          formData.append("first_name", model.value.first_name);
          formData.append("file", model.value.file);
          formData.append("adress", model.value.adress);
          formData.append("birth_date", model.value.birth_date);
          formData.append("cityId", model.value.cityId);
          formData.append("id_user", model.value.id_user);
          formData.append(
            "identification_number",
            model.value.identification_number
          );
          formData.append("last_name", model.value.last_name);
          formData.append("mail", model.value.mail);
          formData.append("phone_number", model.value.phone_number);
          formData.append("status", model.value.status);
          formData.append("is_access", model.value.is_access);
          formData.append("user_name", model.value.user_name);
          formData.append("password", model.value.password);
          formData.append("rolId", model.value.rolId);
          formData.append("type", model.value.type);
          formData.append("idOffice", parser.dataUser.officeEmployee_officeId);
          formData.append("idRol", parser.userData.rolId);

          // eslint-disable-next-line

          store
            .dispatch("app-user/addEmployee", formData)
            .then((response) => {
              toast({
                component: ToastificationContent,
                props: {
                  title: `SUCCESS`,
                  icon: "CheckCircleIcon",
                  text: `${response.data.msg}`,
                  variant: "success",
                },
              });
              router.push({ name: "apps-employee-list" });
            })
            .catch((err) => {
              toast({
                component: ToastificationContent,
                props: {
                  title: `ERROR`,
                  icon: "AlertOctagonIcon",
                  variant: "danger",
                  text: "Employee Exist",
                  solid: true,
                },
              });
            });
        }
      });
    };

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        console.log("ENtre Aqui");
      }
    );

    return {
      avatarText,
      cityOptions,
      rolsOptions,
      statusOptions,
      validations,
      uploadImage,
      imgAvatar,
      model,
      simpleRules,
      validationForm,
      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      maxDate,
      onContext,
      verifyEmail,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
